import request from '@/router/axios'

export function statistics(data) {
  return request({
    url: "/api/business/portalIndex/statistics",
    method: "get"
  })
}

export function requirement_index(data) {
  return request({
    url: "/api/business/portalIndex/requirement_index",
    method: "get"
  })
}